import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import DateSelectionButton from './DateSelectionButton';
import ProfileButton from './ProfileButton';
import useAuth from '@/features/hooks/useAuth';
import useMenu from '@/features/hooks/useMenu';
import { renderIcon } from '@/utils/iconRenderer';
import DateSelection from '@/components/DateSelection';
import useNotificationApi from '@/services/api/useNotificationApi';
import Notifications from '@/components/Notifications';
import Sidebar from '../Sidebar';

export default function Header({ showDateSelection }) {
    const { t } = useTranslation();
    const { user, notifications, setNotifications } = useAuth();
    const { selectedComponentHandler } = useMenu();
    
    // Tarih seçimi, bildirim ve sidebar durumlarını yönetmek için durumlar
    const [isShowDateSelection, setIsShowDateSelection] = useState(false);
    const [isShowNotifications, setIsShowNotifications] = useState(false);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false); // Sidebar durumu
    const [unreadNotifications, setUnreadNotifications] = useState([]);
    const { SetNotification } = useNotificationApi();

    const toggleDateSelection = () => setIsShowDateSelection(!isShowDateSelection);
    const toggleNotifications = async () => {
        setIsShowNotifications(!isShowNotifications);
        if (!isShowNotifications) {
            const result = await SetNotification();
            setNotifications(result);
        }
    };
    const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen); // Sidebar'ı aç/kapat

    useEffect(() => {
        const newUnreadNotifications = notifications.filter(notification => !notification.status);
        setUnreadNotifications(newUnreadNotifications);
    }, [notifications]);

    return (
        <>
            <nav className="flex justify-between flex-row flex-nowrap px-3 py-1 bg-color-header-menu z-header">
                <ul className="p-0 flex flex-row justify-start items-center">
                    <button
                        onClick={toggleSidebar} // Sidebar açma/kapatma işlevi
                        className="text-color-text p-3 rounded-lg"
                    >
                        {renderIcon('menu-outline', 28)}
                    </button>
                </ul>
                <ul className="flex flex-row justify-center items-center">
                    <NavLink
                        to="/"
                        className="text-color-text-gray"
                        onClick={() => selectedComponentHandler("")}
                    >
                        <img
                            src="/images/icons/logo.png"
                            width={36}
                            height={36}
                            className="rounded-full"
                            alt="Logo"
                        />
                    </NavLink>
                </ul>
                <ul className="flex flex-row justify-end items-center list-none gap-1.5">
                    {showDateSelection && (
                        <li>
                            <DateSelectionButton onClick={toggleDateSelection} />
                        </li>
                    )}
                    <li>
                        <button
                            type="button"
                            className="relative p-2 text-gray-500"
                            onClick={toggleNotifications}
                        >
                            {renderIcon('notifications', 24, "text-color-text")}
                            {unreadNotifications.length > 0 && (
                                <span
                                    className="absolute top-0 right-0 transform translate-x-1/3 -translate-y-1/3 bg-red-500 text-white text-xs font-semibold rounded-full px-1.5 py-0.5"
                                    style={{ top: '2px', right: '2px' }}
                                >
                                    {unreadNotifications.length}
                                    <span className="sr-only">{t('OkunmamisMesajlar')}</span>
                                </span>
                            )}
                        </button>
                    </li>
                    <li>
                        <ProfileButton user={user} />
                    </li>
                </ul>

                {/* Tarih Seçim Penceresi */}
                {isShowDateSelection && (
                    <DateSelection isShow={isShowDateSelection} handleDateClick={toggleDateSelection} />
                )}

                {/* Bildirimler Penceresi */}
                {isShowNotifications && (
                    <Notifications
                        notifications={notifications}
                        isShowNotifications={isShowNotifications}
                        setNotificationsClick={toggleNotifications}
                    />
                )}
            </nav>

            {/* Sidebar */}
            <Sidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        </>
    );
}
